import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogConfig } from '@angular/material/dialog';
import { ModalCambioPasswordComponent } from 'src/app/paginas/modal-cambio-password/modal-cambio-password.component';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { MatdialogService } from 'src/app/services/utils/mat-dialog/mat-dialog.service';
import { AuthService } from '../../services/auth/auth.service';
import { UsuariosService } from 'src/app/services/usuarios.service';
import { ModalContenido } from 'src/app/@tema/components/interface/modal-contenido.interface';
import { ModalGenericoComponent } from 'src/app/@tema/components/modal-generico/modal-generico.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  version = environment.appVersion || 0;
  form: FormGroup;
  formReset: FormGroup;
  msjError = null;
  enviarReset = false;
  constructor(private fb: FormBuilder, private authService: AuthService,
              private notificacionesService: NotificacionesService,
              private matdialogService: MatdialogService,
              private serv : UsuariosService,) { }

  ngOnInit(): void {
    this.formInit();
    this.createForm();
  }

  formInit() {
    this.form = this.fb.group({
      username: [null, Validators.required],
      password: [null, Validators.required],
    });
  }

  createForm(){
    this.formReset = this.fb.group({
      loginName: [null, Validators.required],
    });
  }

  ingresar(){
    this.msjError = null;
    if (this.form.invalid){
      return this.abrirModalAviso('Alerta', 'Es necesario colocar el usuario y la contraseña', 'Aceptar',null,'icoAlert');

    }
    this.authService.iniciarSesion(this.form.value).subscribe(resp=> {
      console.log(resp);

      if(resp.data ? resp.data.changePassword : false) this.abrirModal();
      if (!resp.data) this.abrirModalAviso('Error', `${resp.mensaje}`, 'Aceptar',null,'icoError');
      if(!resp.exito)this.msjError = resp.mensaje;

    },err => {
      console.log(err);
      const txtError = err.error ? err.error.mensaje : 'Error de conexión, si el problema persiste contacte al administrador.' ;
      this.abrirModalAviso('Error', `${txtError}`, 'Aceptar',null,'icoError');
    });
  }

  abrirModal(){
    let info: MatDialogConfig  = {
      data: this.form.value,
      height: 'auto',
			width: '400px',
      disableClose: true,
    }
    this.matdialogService.openAfterClosed(ModalCambioPasswordComponent, info ).subscribe(resp =>{
      if(resp){
        this.form.reset();
        this.msjError = null;
      }
    });
  }

  recuperar(){
    this.serv.resetContraseña(this.formReset.value).subscribe(data =>{
      this.enviarReset = false;
      this.form.reset();
      this.abrirModalAviso('Aviso', `${data.resultado}`, 'Aceptar',null,'icoInf');
    },err=>{
      this.abrirModalAviso('Error', 'Se presento un error en su proceso', 'Aceptar',null,'icoError');
    });
  }

  abrirModalAviso(campoTitulo, campoParrafo, btnAceptar, btnCancelar, btn){
    const campos : ModalContenido = {
      titulo : campoTitulo,
      cuerpoParrafo1 : campoParrafo,
      botonAceptar : btnAceptar,
      botonCancelar : btnCancelar,
      icoInf : btn === 'icoInf' ? true : false,
      icoError : btn === 'icoError' ? true : false,
      icoAlert : btn == 'icoAlert' ?  true : false
    }
    let info: MatDialogConfig  = {
      data: campos,
      height: 'auto',
      width:'80%',
      disableClose: true,
      maxWidth: '300px',
    }
    this.matdialogService.openAfterClosed(ModalGenericoComponent,info).subscribe(resp =>{
    })
  }

  hidePassword = true;

  togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
  }



    oauth(){
    this.serv.oauthLogin().subscribe((resp:any) =>{
      console.log('OAuth response:', resp);
      
      // La respuesta de /oauth/login debería ser una URL de redirección
      // No un token directamente
      if (typeof resp === 'string') {
        // Si es un string, es la URL de redirección
        window.location.href = resp;
      } else if (resp && resp.url) {
        // Si es un objeto con propiedad url
        window.location.href = resp.url;
      } else {
        console.error('Estructura de respuesta OAuth inesperada:', resp);
      }
    },err =>{
      console.log(err);
    });
  }


}
